import React from 'react';
import { Link } from 'react-router-dom';

class DetailView extends React.Component {
    constructor(props) {
        super(props); 
    }
    back=()=>{
        this.props.history.goBack();
    }

    render() {
        const {data,title}=this.props.data; 
        return  <div>
            <h3 className="heading_b uk-margin-bottom"> 
                {title} Detail
                <span><button style={{float: 'right',marginTop:'-8px'}} onClick={()=>this.back()} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Back</button></span>
            </h3>
            <div className="md-card">  
                <div className="uk-grid">
                    {
                        data && data.map((val,i)=>{
                            return(
                                <div key={i} className="uk-width-medium-1-2 detail-view">  
                                    <div className="uk-text-muted uk-text-middle text-bold">{val.label}</div>
                                    <div className="uk-text-muted uk-text-middle"><span className="text-bold">:</span> {val.value}</div> 
                                </div>);
                        })
                    }
                  
                </div>
            </div> 
        </div>
        ;
    }

}
 
export default DetailView;


// WEBPACK FOOTER //
// ./src/core/DetailView.js